import doctorMekConfig from '@/config/doctor-mek'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: doctorMekConfig.END_POINT,
    timeout: 30000,
    headers: {
      AUTHORIZATION: doctorMekConfig.AUTH
    }
  })

const doctorMakApi = {
  getPamUserInFo: (config) => {
    return instance().get('', config)
  }
}
export default doctorMakApi



// WEBPACK FOOTER //
// ./src/api/doctor-mek.js